import { memo } from 'react';
import { Alert, Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-core';
import { ContentNode } from '@amzn/awscat-pattern-library-service-model';

import {
  NODE_SHORT_TITLE_MAX_LENGTH,
  NODE_SHORT_TITLE_MIN_LENGTH,
  PAGE_TITLE_MAX_LENGTH,
  PAGE_TITLE_MIN_LENGTH,
} from '../v2-common/InlineValidations';
import TitleInput from '../v2-common/TitleInput';
import { useEditPageButtonViewModel } from './EditPageButtonViewModel';

interface EditPageButtonProps {
  readonly currentPage: ContentNode;
}

const EditPageButton = memo(function EditPageButton({ currentPage }: EditPageButtonProps) {
  const vm = useEditPageButtonViewModel(currentPage);

  return (
    <>
      <Button variant="icon" iconName="edit" ariaLabel="Edit page title" onClick={vm.openModal} />
      {vm.isModalVisible && (
        <Modal
          visible
          header="Edit Page Title"
          onDismiss={vm.dismissModal}
          footer={
            <Box float="right">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={vm.dismissModal}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  disabled={!vm.isSaveEnabled}
                  loading={vm.isSaving}
                  onClick={vm.confirmSave}
                >
                  Save
                </Button>
              </SpaceBetween>
            </Box>
          }
        >
          <SpaceBetween direction="vertical" size="s">
            <TitleInput
              label="Page title"
              initialTitle={vm.title}
              minLength={PAGE_TITLE_MIN_LENGTH}
              maxLength={PAGE_TITLE_MAX_LENGTH}
              onTitleChanged={vm.updateTitle}
              autoFocus
            />
            <TitleInput
              label={
                <>
                  Short title - <i>optional</i>
                </>
              }
              initialTitle={vm.shortTitle}
              minLength={NODE_SHORT_TITLE_MIN_LENGTH}
              maxLength={NODE_SHORT_TITLE_MAX_LENGTH}
              onTitleChanged={vm.updateShortTitle}
            />
            {vm.saveErrorMessage !== undefined && <Alert type="error">{vm.saveErrorMessage}</Alert>}
          </SpaceBetween>
        </Modal>
      )}
    </>
  );
});

export default EditPageButton;
